import React, { useEffect, useState } from 'react';
import Text from '../common/ui/Text';
import { ImageContainer, Image } from '../common/ui/Image';
import { ItemCard, ItemText } from './Component';
import './index.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.min.css';

SwiperCore.use([ Navigation, Pagination ]);

const Carousel = (props) => {
    const [items, setItems] = useState([]);
    const [screenSize, setScreenSize] = useState(null);

    useEffect(() => {
        setScreenSize(window.screen.width);
        setItems(props.slides);
    }, [] );

    let { xsSlidesPerView, sSlidesPerView, mSlidesPerView, lSlidesPerView, xlSlidesPerView, xsspacebetweenslides, sspacebetweenslides, mspacebetweenslides, lspacebetweenslides, xlspacebetweenslides, xxlSlidesPerView } = props;

    return (
        <Swiper
            pagination={{ clickable:true }}
            navigation={props.navigation}
            loopAdditionalSlides={1000}
            centeredSlides= {true}
            loop={true}
            initialSlide={2}
            slidesPerView={screenSize < 481 ? xsSlidesPerView : (screenSize < 768 ? sSlidesPerView : (screenSize < 992 ? mSlidesPerView : (screenSize < 1024 ? lSlidesPerView : (screenSize < 1260 ? xlSlidesPerView : xxlSlidesPerView ))))}
            spacebetweenslides={50}
            overflow={props.backgroundImage ? "backgroundoverflow" : "overflow"}
            style={{ width:props.backgroundImage ? (screenSize > 1024 ? "100%":"90%") : "" }}
        >{
            items.map((el,i) => {
                return (
                    <SwiperSlide 
                        key={el.id}
                        style={{ transform:props.backgroundImage ? "scale(1)": "scale(0.9)" }}
                    >
                        <Item 
                            {...el} 
                            {...props}
                            screen={screenSize}
                        />
                    </SwiperSlide>
                )
            })
        }
        </Swiper>
    )
}

class Item extends React.Component {
    render() {
        let { rating, boxShadow, imageWidth, src, opacity, name, text, backgroundImage, itemWidth, screen, alt } = this.props;
        let arr = Array(5).fill(1, 0, rating);
        arr = arr.fill(0, rating);
        return(
            <ItemCard 
                boxShadow={boxShadow} 
                maxWidth={backgroundImage ? "217px" : "340px" } 
                width={itemWidth} 
                margin={backgroundImage ? "40px auto" : undefined}
            >
                <ImageContainer
                    width={imageWidth ? imageWidth : "100%"}
                    backgroundColor={rating ? "DARK_GREY" : ""}
                    borderRadius="6px 6px 0px 0px"
                >
                    <Image 
                        src={src}  
                        width="100%"
                        style={{ borderRadius:backgroundImage ? "0px": "inherit", opacity:opacity, padding:backgroundImage && "10% 4px 9%" }}
                        alt={alt || "Chqbook"}
                    />
                </ImageContainer>
                <ItemText 
                    borderRadius="0px 0px 6px 6px" 
                    background="white"
                >
                    {rating && name && <Text
                        size={screen > 768 ? "xs" : "sm" }
                        weight="bold"
                        padding="5px 0px 0px"
                        color="BLACK"
                        opacity={screen > 768 ? "0.7" : "1" }
                    >
                    {name.toUpperCase()}{" "}{ arr.map((el, i) => (
                        <span key={i}>
                            {el ? <Image 
                                    style={{ margin:screen > 768 ? "-4px 2px 0px": "-2px 2px 0px" }} 
                                    width={screen > 768 ? "13px" : "11px"} 
                                    src="https://res.cloudinary.com/chqbook/image/upload/q_auto,f_auto/v1602183169/chqbookWeb/0-5kb/star-filled.png" 
                            /> : <Image
                                    src="https://res.cloudinary.com/chqbook/image/upload/q_auto,f_auto/v1602183178/chqbookWeb/0-5kb/star-not-filled.png" style={{ margin:screen > 768 ? "-4px 2px 0px": "-2px 2px 0px" }} 
                                    width={screen > 768 ? "13px" : "11px"} 
                                />}
                        </span>
                    ))}
                    </Text>}
                    {text && <Text
                        size={screen > 768 ? "md" : "lg" }
                        padding="5px 15px"
                        sPadding="7px 10px 15px"
                        color="BLACK"
                        letterSpacing="1"
                    >
                    {text}
                    </Text>}
                </ItemText>
            </ItemCard>
        )
    }
}

export default Carousel;